import React from 'react';
import {
  List,
  Create,
  Edit,
  Show,
  Datagrid,
  TextField,
  EmailField,
  TextInput,
  SimpleForm,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ShowButton,
  EditButton,
  TabbedForm,
  TabbedShowLayout,
  Tab,
  FormTab,
  DateField,
  ReferenceManyField,
  ImageInput,
  ImageField,
  required,
} from 'react-admin';
import { parse } from 'qs';
import Icon from '@material-ui/icons/SentimentSatisfied';

import EditActions from './EditActions';
import Title from './Title';
import Avatar from './Avatar';
import FullNameField from 'components/FullNameField';
import UploadToolbar from 'components/UploadToolbar';
import PictureNote from 'components/PictureNote';

export const ServiceConsultantIcon = Icon;

const validateMobile = values => {
  const errors = {};
  if (values.mobile && !values.mobile.startsWith('+')) {
    errors.mobile = ['Mobile should start with +'];
  }
  return errors;
};

export const ServiceConsultantList = props => (
  <List {...props} filter={false} title="Service Consultant">
    <Datagrid>
      <FullNameField />
      <EmailField source="email" />
      <TextField source="mobile" />
      <ReferenceField label="Car Brand" sortBy="car_brands.name" source="car_brand_id" reference="brands">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="abbreviation" label="Autoline ID" />
      <TextField source="abbreviation_sol" label="SOL ID" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export const ServiceConsultantShow = props => (
  <Show title={<Title />} {...props}>
    <TabbedShowLayout>
      <Tab label="Information">
        <ReferenceField source="car_brand_id" reference="brands">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="avatar_url" />
        <TextField source="full_name" />
        <TextField source="email" type="email" />
        <TextField source="mobile" />
        <TextField source="abbreviation" label="Autoline ID" />
        <TextField source="abbreviation_sol" label="SOL ID" />
        <Avatar />
      </Tab>
      <Tab label="Assigned Cars">
        <ReferenceManyField
          addLabel={false}
          sort={{ field: 'reg_no', order: 'DESC' }}
          reference="cars"
          target="service_consultant_id"
        >
          <Datagrid>
            <ReferenceField label="Customer" source="user_id" reference="customers">
              <FullNameField source="last_name" />
            </ReferenceField>
            <TextField source="reg_no" />
            <DateField source="reg_date" />
            <TextField source="chasis_no" label="Chassis no" />
            <ReferenceField label="Car Model" source="car_model.id" reference="models">
              <TextField source="name" />
            </ReferenceField>
            <DateField source="last_service_date" showTime={true} />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export const ServiceConsultantCreate = props => {
  const query = parse(props.location.search, { ignoreQueryPrefix: true });
  let redirect = 'edit',
    brand_id = '';
  if (query.brand_id) {
    brand_id = parseInt(query.brand_id, 10);
    redirect = `/brands/${brand_id}/4`;
  }

  return (
    <Create title={'New Service Consultant'} {...props}>
      <SimpleForm
        defaultValue={{ car_brand_id: brand_id }}
        redirect={redirect}
        toolbar={<UploadToolbar source={['avatar_url']} />}
        validate={validateMobile}
      >
        <ReferenceInput source="car_brand_id" reference="brands" validate={required()} perPage={-1}>
          <SelectInput source="name" />
        </ReferenceInput>
        <TextInput source="full_name" validate={required()} />
        <TextInput source="email" type="email" validate={required()} />
        <TextInput source="mobile" validate={required()} />
        <TextInput source="abbreviation" label="Autoline ID" validate={required()} />
        <TextInput source="abbreviation_sol" label="SOL ID" validate={required()} />
        <ImageInput source="qavatar_url" label="Avatar" accept="image/jpeg,image/png" validate={required()}>
          <ImageField source="src" title="title" />
        </ImageInput>
        <PictureNote width="200" height="200" />
      </SimpleForm>
    </Create>
  );
};

export const ServiceConsultantEdit = props => {
  const query = parse(props.location.search, { ignoreQueryPrefix: true });
  let redirect = 'list',
    brand_id = '';
  if (query.brand_id) {
    brand_id = parseInt(query.brand_id, 10);
    redirect = `/brands/${brand_id}/4`;
  }
  return (
    <Edit title={<Title />} {...props} actions={<EditActions />}>
      <TabbedForm redirect={redirect} toolbar={<UploadToolbar source={['avatar_url']} />} validate={validateMobile}>
        <FormTab label="Information">
          <ReferenceInput source="car_brand_id" reference="brands" disabled perPage={-1}>
            <SelectInput source="name" />
          </ReferenceInput>
          <TextInput source="full_name" validate={required()} />
          <TextInput source="email" type="email" validate={required()} />
          <TextInput source="mobile" validate={required()} />
          <TextInput source="abbreviation" label="Autoline ID" validate={required()} />
          <TextInput source="abbreviation_sol" label="SOL ID" validate={required()} />
          <Avatar />
          <ImageInput source="qavatar_url" label="Avatar" accept="image/jpeg,image/png">
            <ImageField source="src" title="title" />
          </ImageInput>
          <PictureNote width="200" height="200" />
        </FormTab>
        <FormTab label="Assigned Cars">
          <ReferenceManyField
            addLabel={false}
            sort={{ field: 'reg_no', order: 'DESC' }}
            reference="cars"
            target="service_consultant_id"
          >
            <Datagrid>
              <ReferenceField label="Customer" source="user_id" reference="customers">
                <FullNameField source="last_name" />
              </ReferenceField>
              <TextField source="reg_no" />
              <DateField source="reg_date" />
              <TextField source="chasis_no" label="Chassis no" />
              <ReferenceField label="Car Model" source="car_model.id" reference="models">
                <TextField source="name" />
              </ReferenceField>
              <DateField source="last_service_date" showTime={true} />
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/containers/ServiceConsultant/index.js